import useBootstrapData from '@/hooks/useBootstrapData'
import { useMemo } from 'react'
import { initialState } from '../SearchForm/utils'
import type { PackagesFormStateType } from '../types'

const usePackagesFormInitialValues = () => {
  const {
    isMobile,
    prePopData,
    webstats: { clientGUID: cguid },
    locale: { localeCode = 'en-US' } = {},
  } = useBootstrapData()

  const {
    tripType,
    startDate: prePopStartDate,
    endDate: prePopEndDate,
    startLocation,
    endLocation,
    adultCount,
    childrenCount,
    infantCount,
    roomCount,
  } = prePopData?.packages ?? {}

  const initialValues: PackagesFormStateType = useMemo(
    () => ({
      ...initialState,
      ...(tripType && { tripType }),
      ...(prePopStartDate && { startDate: prePopStartDate }),
      ...(prePopEndDate && { endDate: prePopEndDate }),
      ...(startLocation && { startLocation }),
      ...(endLocation && { endLocation }),
      travelers: {
        adults: adultCount || 2,
        children: childrenCount || 0,
        lapInfants: infantCount || 0,
        childrenAges: {},
        rooms: roomCount || 1,
      },
    }),
    [
      tripType,
      prePopStartDate,
      prePopEndDate,
      startLocation,
      endLocation,
      adultCount,
      childrenCount,
      infantCount,
      roomCount,
    ],
  )

  return {
    initialValues,
    isMobile,
    cguid,
    localeCode,
  }
}

export default usePackagesFormInitialValues
